import React, { useState } from "react";
import styled from "styled-components";
import Logo from "./Logo";
import Hamburguesa from "./Hamburguesa";
import Navegacion from "./Navegacion";
import {withRouter} from "react-router-dom";

// Estilos con StyledComponents
const DivPrincipal = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;





const Header = styled.header`

width: 100%;
margin-bottom: 50px;
background-color: #E63946;
`


const HeaderComponent = (props) => {
  const [desactivado, activarMenu] = useState(true);
  return (
    <Header>
      <DivPrincipal>
      
      
        <Logo 
        className="logo-svg" 
        desactivado={desactivado} 
        onClick={()=>{
          props.history.push("/");
        }}
        />
        <Navegacion 
      desactivado={desactivado} 
    
      />
        <Hamburguesa
          desactivado={desactivado}
          activarMenu={activarMenu}
        />
   
      
      </DivPrincipal>
    </Header>
  );
};

export default withRouter(HeaderComponent);
